module.exports = __webpack_public_path__ + "assets/img/00008.078d91f6.png";